import { useEffect, useState } from "react";
import { getConfig } from "./api";

export function useConfig() {
  const [cfg, setCfg] = useState(null);
  useEffect(() => {
    let alive = true;
    getConfig().then((c) => {
      if (alive) setCfg(c);
    });
    return () => {
      alive = false;
    };
  }, []);
  return cfg;
}
